import React from "react";
import "./SingleCatList.css";
import { Nut } from "../../../../images/Images";
import SingleCatCard from "./SingleCatCard";

const products = [
  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },
];

const SingleCatList: React.FC = () => {
  return (
    <div className="single-cat-listing">
      <h2 className="single-cat-list__title">Vegetables</h2>
      <div className="single-cat-list__grid">
        {products.map((product, index) => (
          <SingleCatCard key={index} {...product} />
        ))}
      </div>
    </div>
  );
};

export default SingleCatList;
